import { render, staticRenderFns } from "./OrderAdminSUP.vue?vue&type=template&id=09546e78&scoped=true"
import script from "./OrderAdminSUP.vue?vue&type=script&lang=js"
export * from "./OrderAdminSUP.vue?vue&type=script&lang=js"
import style0 from "./OrderAdminSUP.vue?vue&type=style&index=0&id=09546e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09546e78",
  null
  
)

export default component.exports